/**
 * Stable string→fraction hash with FULL avalanche — FNV-1a plus a
 * murmur-style finalizer. The shared primitive behind every "same key, same
 * outcome forever" assignment in the crowd layouts (GA scatter axes, the
 * perimeter character cast).
 *
 * Why not a simple `h*31+c`: platform userIds are frequently near-identical
 * strings (sequential numerics, test-crowd ids), and a weak hash maps
 * neighbors to neighboring fractions — the whole GA crowd bunched into one
 * clump (found live 2026-07-12). Salting yields independent axes per use.
 */

function hashFrac(str, salt = 0) {
  let h = (2166136261 ^ salt) >>> 0;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 16777619);
  }
  h ^= h >>> 16;
  h = Math.imul(h, 0x85ebca6b);
  h ^= h >>> 13;
  h = Math.imul(h, 0xc2b2ae35);
  h ^= h >>> 16;
  return (h >>> 0) / 4294967296;
}

module.exports = { hashFrac };
